import { enumType } from '@shared/core/types/common';

enum CART_LOGOUT_MODE {
    ASK_CLEAR_ON_LOGOUT = OLO.Enums.CART_LOGOUT_MODE.ASK_CLEAR_ON_LOGOUT,
    CLEAR_ON_LOGOUT = OLO.Enums.CART_LOGOUT_MODE.CLEAR_ON_LOGOUT,
    NOT_CLEAR_ON_LOGOUT = OLO.Enums.CART_LOGOUT_MODE.NOT_CLEAR_ON_LOGOUT,
}

export const cartLogoutModeEnum = enumType('CART_LOGOUT_MODE', CART_LOGOUT_MODE);
